import type { ReactNode } from "react";
import { ApogeuLogo } from "./ApogeuLogo";
import { BottomNavigation } from "./BottomNavigation";
import type { AppTab, AppTabId } from "../lib/navigation";

interface AppShellProps {
  readonly ctName: string;
  readonly roleLabel: string;
  readonly userName: string;
  readonly tabs: readonly AppTab[];
  readonly activeTab: AppTabId;
  readonly onTabChange: (tab: AppTabId) => void;
  readonly children: ReactNode;
}

export function AppShell({ ctName, roleLabel, userName, tabs, activeTab, onTabChange, children }: AppShellProps) {
  const initial = userName.trim().charAt(0).toUpperCase() || "A";

  return (
    <div className="app-frame">
      <div className="shell">
        <header className="shell__header">
          <div className="shell__identity">
            <ApogeuLogo width={68} />
            <div className="shell__context">
              <span className="shell__eyebrow">Apogeu App</span>
              <span className="shell__ct" title={ctName}>{ctName}</span>
            </div>
          </div>
          <div className="shell__account">
            <span className="role-pill">{roleLabel}</span>
            <span className="avatar" title={userName} aria-hidden="true">{initial}</span>
          </div>
        </header>
        <main className="shell__main">{children}</main>
        <BottomNavigation tabs={tabs} activeTab={activeTab} onTabChange={onTabChange} />
      </div>
    </div>
  );
}
